import React from 'react'

import { Text, FontFamily, FontWeight, Color, Display } from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'

export const ProteinText = ({ recipe }: { recipe: Recipe }) => {
  const proteinToDisplay = recipe.nutritionalInformation.perPortion.proteinMg

  if (!proteinToDisplay) {
    return null
  }
  const roundedProtein = parseFloat((proteinToDisplay / 1000).toFixed(1))

  return (
    <Text
      size={2}
      fontFamily={FontFamily.Book}
      fontWeight={FontWeight.Normal}
      color={Color.ColdGrey_600}
      display={Display.Inline}
      data-testid={'protein-text'}
    >
      &nbsp;&nbsp;|&nbsp;&nbsp;{`${roundedProtein}g protein`}
    </Text>
  )
}
